export default __webpack_public_path__ + "static/media/kotebetta_trek.998ca684.jpg";